
import ReactGA from 'react-ga4';

// Initialize Google Analytics with your Measurement ID
export const initGA = () => {
  ReactGA.initialize('G-H5B9Y0XGWP');
};

// Track page views
export const trackPageView = (path: string, options?: Record<string, any>) => {
  const eventParams = options ? { ...options } : {};
  ReactGA.send({ 
    hitType: 'pageview', 
    page: path,
    ...eventParams 
  });
};

// Track custom events
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};

// Track user interactions
export const trackInteraction = (action: string, label?: string) => {
  trackEvent('User Interaction', action, label);
};

// Track profile actions
export const trackProfileAction = (action: string, profileId?: string) => {
  trackEvent('Profile', action, profileId);
};

// Track social shares
export const trackSocialShare = (platform: string, contentId?: string) => {
  trackEvent('Social Share', platform, contentId);
};
